import { createFileRoute } from '@tanstack/react-router';
import LogsTab from '../../../components/account-management/settings/logs-tab/LogsTab';
import Loader from '../../../components/shared/custom-components/Loader';

export const Route = createFileRoute('/_authenticated/settings/logs')({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: LogsTab as any,
});
